<app-send-email [verificationCodeUrl]="'/auth/resetPassword/verifyCode'"
                [loginUrl]="'/auth/login'"></app-send-email>
